export const errorMessage = {
	invalid_user_credentials: 'Неверные логин или пароль',
	user_not_found: 'Пользователь не найден',
	email_invalid: 'Некорректный e-mail',
	email_already_taken: 'Пользователь с таким email уже зарегистрирован',
	login_already_taken: 'Пользователь с таким логином уже зарегистрирован',
	password_invalid: 'Пароль содержит недопустимые символы',
	password_too_weak:
		'Пароль слишком слабый. Попробуйте сделать его длинее, добавив заглавные буквы и специальные символы',
	password_too_short: 'Пароль должен содержать не менее 8 символов',
	password_not_match: 'Пароли не совпадают',
	user_login_too_short: 'Логин должен содержать не менее 3 символов',
	user_login_contains_invalid_characters: 'Логин содержит недопустимые символы',
	login_invalid: 'Логин содержит недопустимые символы',
	login_too_short: 'Логин должен содержать не менее 3 символов',
	promo_code_limit_exceeded: 'Промо-код просрочен',
	promo_code_not_found: 'Промо-код не наиден',
	otp_not_matched: 'Код верификации не совпадает',
	problem_on_server_side: 'Произошла непредвиденная ошибка, попробуйте позже',
};
